import { ISearchItem } from 'models/ISearchItem';
import { SearchHeading, SearchList } from './searchList';
import { NO_ELEMENT, rm } from 'utils';
import { useSelector } from 'react-redux';
import { selectIsThecaSearchEnabled } from 'store/appShell/selector';

interface OwnProps {
  show?: boolean;
  searchItems: ISearchItem[];
  heading: string;
  isMobile?: boolean;
  children: (item: ISearchItem) => JSX.Element;
  className?: string;
}

export const SearchResultBlock = ({
  show,
  isMobile,
  heading,
  className,
  searchItems,
  children
}: OwnProps) => {
  const isThecaEnabled = useSelector(selectIsThecaSearchEnabled);
  const showHeading = isThecaEnabled && heading.includes(`${rm('search_new_nohits')}`);
  return show ? (
    <>
      {!showHeading && <SearchHeading hide={isMobile}>{heading}</SearchHeading>}
      {<SearchList className={className}>{searchItems.map(children)}</SearchList>}
    </>
  ) : (
    NO_ELEMENT
  );
};
